/* import __COLOCATED_TEMPLATE__ from './move-finish-record-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class MoveFinishRecordComponent extends Component 
{
	@service store;
	@service ajax;
	
	@tracked destinationEvent = null;
	@tracked recordID = null;
	
	@action
	async destinationEventChanged(browserEvent)
	{		
		if(browserEvent.target.value == '-')
		{
			this.destinationEvent = null;
		}
		else
		{
			const event = await this.store.findRecord('Event', browserEvent.target.value, { reload: true });
			this.destinationEvent = event;
		}
	}
	
	@action
	async moveRecord()
	{	
		if(this.recordID != null)
		{
			const finishTimingRecord = await this.store.findRecord('FinishTimingRecord', this.recordID);
			
			finishTimingRecord.EventId = this.destinationEvent;
			finishTimingRecord.EntryId = null;
			await finishTimingRecord.save();
			this.recordID = null;
		}
	}
}
